document.addEventListener('DOMContentLoaded',function(){
  const productWrapper = document.querySelector('.main-product');
  const body = document.body;

  if (!productWrapper) {
    return;
  }

  const productTemplate = productWrapper.dataset.template;
  const lang = document.querySelector('html').getAttribute('lang');

  // checking language
  if (productTemplate == 'rectangular') {
    const observerLanguage = new MutationObserver(() => {
      const options = document.querySelector('.bss-po-product-page');
      if (options) {
        observerLanguage.disconnect();
        handleOptionsUpdate(options, 'Language', lang);
      }
    });

    observerLanguage.observe(document.body, { childList: true, subtree: true });
  }  

  // blocks translate (start)
  let trsFrameColor = '',
      trsHeight = '',
      trsEpoxyColor = '',
      trsFrameStyle = '';
      trsEpoxyColor = '';

  if (lang == 'en') {
    trsHeight = 'Height';
    trsEpoxyColor = "Epoxy";
    trsFrameStyle = 'Frame style';
    trsFrameColor = 'Frame color';
  } else if (lang == 'de') {    
    trsHeight = 'Höhe';
    trsEpoxyColor = "Epoxidharz";
    trsFrameStyle = 'Tischgestell';
    trsFrameColor = 'Farbe des Gestells';
  }
  // blocks translate (end)

  function changePopup(block) {   
    if (block) {
      const label = block.querySelector('.hc-drawer-label-js');
      if (!label) {
        return;
      }     

      label.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('body').classList.add('hc-drawer-active');
        block.querySelector('.hc-popup-drawer').classList.add('hc-popup-drawer-active');
        block.querySelector('.hc-drawer-overlay').classList.add('hc-drawer-overlay-active');      
      })
    
      block.querySelector('.hc-drawer-top span.cros').addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('body').classList.remove('hc-drawer-active');
        block.querySelector('.hc-popup-drawer').classList.remove('hc-popup-drawer-active');
        block.querySelector('.hc-drawer-overlay').classList.remove('hc-drawer-overlay-active');
      })  
    
      block.querySelector('.hc-drawer-overlay').addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('body').classList.remove('hc-drawer-active');
        block.querySelector('.hc-popup-drawer').classList.remove('hc-popup-drawer-active');
        block.querySelector('.hc-drawer-overlay').classList.remove('hc-drawer-overlay-active');
      })
    }
  }

  function changeActive(block, item, event) {
    document.querySelector('body').classList.remove('hc-drawer-active');
    block.querySelector('.hc-popup-drawer').classList.remove('hc-popup-drawer-active');
    block.querySelector('.hc-drawer-overlay').classList.remove('hc-drawer-overlay-active');

    if(item == true) {
      block.querySelectorAll('.hc-drawer-val').forEach(t => {t.classList.remove('hc-drawer-val-active')});
      event.target.closest(`.hc-drawer-val`).classList.add('hc-drawer-val-active');
    }    
  }

  // frame color (start)
  const blockColors = document.querySelectorAll('.hc-drawer-color');      
  const colNameFormColor = document.querySelector('.communication__form_frame_color');  
 
  if (productTemplate == 'round' && blockColors || productTemplate == 'rectangular-frame' && blockColors) {
    blockColors.forEach((block) => {
      changePopup(block);

      communicationForm(blockColors, colNameFormColor);

      block.querySelectorAll('.hc-drawer-val').forEach(el => {     
        el.addEventListener('click', (e) => {
            e.preventDefault();          
            changeActive(block, true, e);

            let dataVal = e.target.closest(`.hc-drawer-val`).getAttribute('data-colval');          
            let inputColorFrame = document.querySelector('.product-form input.product_frame_color');
            let dataColor = e.target.closest(`.hc-drawer-val`).getAttribute('data-color');
            let colColor = block.querySelector('.col-color');
            let colNameForm = document.querySelector('.communication__form_frame_color');

            if (dataColor) {
              colColor.style.background = dataColor;
            }          
            
            warningOptions(block);
            inputColorFrame.value = dataVal;

            if (colNameForm) {              
              colNameForm.value = dataVal;
            }
        })
      })
    })
  } else if (productTemplate == 'rectangular' && blockColors || productTemplate == 'one-size-rectangular' && blockColors) {
    const observer = new MutationObserver(() => {
      const options = document.querySelector('.bss-po-product-page');

      if (options) {
        observer.disconnect();
        handleBlocksColors(blockColors, options);
      }
      
      communicationForm(blockColors, colNameFormColor)
    });

    observer.observe(document.body, { childList: true, subtree: true });

    function handleBlocksColors(blockColors, options) {
      blockColors.forEach((block) => {
        changePopup(block);
        handleBlockClickColors(block, options);
      });
    }
    
    function handleBlockClickColors(block, options) {
      const defaultFrameColor = block.querySelector('.hc-drawer-blocks').dataset.frameColor;
      handleOptionsUpdate(options, trsFrameColor, defaultFrameColor);      

      block.addEventListener('click', (e) => {
        if (e.target.classList.contains('hc-drawer-val')) {
          e.preventDefault();
          changeActive(block, true, e);        
    
          const dataVal = e.target.getAttribute('data-colval');
          const inputColorFrame = document.querySelector('.product-form input.product_frame_color');
          const dataColor = e.target.getAttribute('data-color');
          const colColor = block.querySelector('.col-color');
          const dataType = e.target.getAttribute('data-type');
          let colNameForm = document.querySelector('.communication__form_frame_color');
          
          if (dataColor) {
            colColor.style.background = dataColor;
          }

          if (colNameForm) {            
            colNameForm.value = dataVal;
          }
    
          warningOptions(block);
          handleOptionsUpdate(options, trsFrameColor, dataVal);
          inputColorFrame.value = dataVal;
        }
      });
    }
  }
  // frame color (end)

  // frame 
  const blockFrameSquare = document.querySelectorAll('.hc-drawer-size-frame');
  const blockFrame = document.querySelectorAll('.hc-drawer-frame');
  const colNameForm = document.querySelector('.communication__form_frame');

  if (productTemplate == 'round' && blockFrameSquare || productTemplate == 'one-size-rectangular' && blockFrameSquare || productTemplate == 'rectangular-frame' && blockFrameSquare) {
    blockFrameSquare.forEach((block) => {
      changePopup(block);

      communicationForm(blockFrameSquare, colNameForm)

      block.querySelectorAll('.hc-drawer-val').forEach(el => {     
    
        el.addEventListener('click', (e) => {
            e.preventDefault();
            changeActive(block, true, e);

            let dataVal = e.target.closest(`.hc-drawer-val`).getAttribute('data-colval');
            let dataIcon = e.target.closest(`.hc-drawer-val`).getAttribute('data-icon');   
            let colIcon = block.querySelector('.lab_image img');
            let colName = block.querySelector('.product-variant__name');
            let colNameForm = document.querySelector('.communication__form_frame');
            
            colName.textContent = dataVal;
            colIcon.src = dataIcon;   

            if (colNameForm) {
              colNameForm.value = dataVal;
            }     
            
            warningOptions(block)
            e.target.closest(`.hc-drawer-val`).closest(`.product-variant`).querySelector(`input[value="${dataVal}"]+.product-variant__label`).click();     
        })
      })
    });
  } else if (productTemplate == 'rectangular' && blockFrame) {
    const observer = new MutationObserver(() => {
      const options = document.querySelector('.bss-po-product-page');      
      
      if (options) {
        observer.disconnect();
        handleBlocksFrame(blockFrame, options);
      }      

      communicationForm(blockFrame, colNameForm);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    function handleBlocksFrame(blockFrame, options) {
      blockFrame.forEach((block) => {
        changePopup(block);
        handleBlockClickFrame(block, options);
      });
    }
    
    function handleBlockClickFrame(block, options) {
      const defaultFrame = block.querySelector('.hc-drawer-blocks').dataset.frame;

      if (!body.classList.contains('from-collection')) {
        handleOptionsUpdate(options, trsFrameStyle, defaultFrame);
      }      
      
      block.querySelectorAll('.hc-drawer-val').forEach(el => {    
        el.addEventListener('click', (e) => {
          e.preventDefault();
          changeActive(block, true, e);

          let dataVal = e.target.closest(`.hc-drawer-val`).getAttribute('data-colval');
          let dataIcon = e.target.closest(`.hc-drawer-val`).getAttribute('data-icon');   
          let colIcon = block.querySelector('.lab_image img');
          let colName = block.querySelector('.product-variant__name');
          let colNameForm = document.querySelector('.communication__form_frame');
            
          colName.textContent = dataVal;          
          colIcon.src = dataIcon;
          
          if (colNameForm) {
            colNameForm.value = dataVal;
          }

          warningOptions(block);
          handleOptionsUpdate(options, trsFrameStyle, dataVal);
        })
      })
    }
  }

  // size block
  const blockSize = document.querySelectorAll('.hc-drawer-size');

  if (blockSize) {
    blockSize.forEach((block) => {
      changePopup(block);     
  
      block.querySelectorAll('.hc-drawer-val').forEach(el => { 
        let comFormWidth = document.querySelector('.communication__form_width');
        let comFormLength = document.querySelector('.communication__form_length');
        let comFormDiameter = document.querySelector('.communication__form_diameter');
  
        var temp_val = el.getAttribute('data-colval')
        if (el.closest(`.product-variant`).querySelector(`input[value="${temp_val}"][disabled="disabled"]`)) {
          el.classList.add('hc-is-soldout')
        }

        if (comFormWidth) {
          communicationsOptions('default', 'width', '', comFormWidth);
        }
        if (comFormLength) {
          communicationsOptions('default', 'length', '', comFormLength);
        }
        if (comFormDiameter) {
          communicationsOptions('default', 'diameter', '', comFormDiameter);
        }
    
        el.addEventListener('click', (e) => {
          e.preventDefault();     
          changeActive(block, true, e);

          let dataVal = e.target.closest(`.hc-drawer-val`).getAttribute('data-colval')
          let colSize = block.querySelector('.col-name .col-size-value');        

          if (comFormWidth) {
            communicationsOptions('click', 'width', dataVal, comFormWidth);
          }
          if (comFormLength) {
            communicationsOptions('click', 'length', dataVal, comFormLength);
          }
          if (comFormDiameter) {
            communicationsOptions('click', 'diameter', dataVal, comFormDiameter)
          }
          
          colSize.textContent = dataVal;
          
          warningOptions(block)
          e.target.closest(`.hc-drawer-val`).closest(`.product-variant`).querySelector(`input[value="${dataVal}"]+.product-variant__label`).click();
                    
        })

        function communicationsOptions(type, optionsName, valueOption, formInput) {
          if (type == 'default') {
            const blockParrent = block.querySelector(`.hc-drawer-items-${optionsName}`)
            if (blockParrent) {
              const items = blockParrent.querySelectorAll('.hc-drawer-val');

              items.forEach((item) => {
                if (item.classList.contains('hc-drawer-val-active')) {                  
                  formInput.value = item.dataset.colval + 'cm';
                }
              })
            }   
          }          

          if (type == 'click') {
            if (el.parentElement.classList.contains(`hc-drawer-items-${optionsName}`)) {
              formInput.value = valueOption + 'cm';         
            }
          }          
        }
      })
    })
  }

  // epoxy block
  const blockEpoxy = document.querySelectorAll('.hc-drawer-epoxy');

  if (productTemplate == 'round' && blockEpoxy) {
    blockEpoxy.forEach((block) => {
      let inputBuy = document.querySelector('.product-form input.product_epoxy');
  
      changePopup(block);
  
      block.querySelectorAll('.hc-drawer-val').forEach((el) => {  
        el.addEventListener('click', (e) => {
            e.preventDefault();
            changeActive(block, true, e);
  
            let dataVal = e.target.closest(`.hc-drawer-val`).getAttribute('data-colval');
            let colColor = block.querySelector('.col-color');
            let dataColor = e.target.closest(`.hc-drawer-val`).getAttribute('data-color');
            let dataColorGradient = e.target.closest(`.hc-drawer-val`).getAttribute('data-color-gradient');          
  
            if (dataColor) {
              colColor.style.background = dataColor;
            } else if (dataColorGradient) {
              colColor.style.background = dataColorGradient;
            }
            
            inputBuy.value = dataVal;
        })
      })
    })
  } else if (productTemplate == 'rectangular' && blockEpoxy) {  
    const observer = new MutationObserver(() => {
      const options = document.querySelector('.bss-po-product-page');
      if (options) {
        observer.disconnect();
        handleBlocksEpoxy(blockEpoxy, options);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    function handleBlocksEpoxy(blockEpoxy, options) {
      blockEpoxy.forEach((block) => {
        changePopup(block);
        handleBlockClickEpoxy(block, options);
      });
    }
    
    function handleBlockClickEpoxy(block, options) {
      const defaultEpoxy = block.querySelector('.hc-drawer-blocks').dataset.epoxy;
      handleOptionsUpdate(options, trsEpoxyColor, defaultEpoxy);

      block.querySelectorAll('.hc-drawer-val').forEach((el) => {  
        el.addEventListener('click', (e) => {
          e.preventDefault();
          changeActive(block, true, e);

          let dataVal = e.target.closest(`.hc-drawer-val`).getAttribute('data-colval');
          let colColor = block.querySelector('.col-color');
          let dataColor = e.target.closest(`.hc-drawer-val`).getAttribute('data-color');
          let dataColorGradient = e.target.closest(`.hc-drawer-val`).getAttribute('data-color-gradient');

          if (dataColor) {
            colColor.style.background = dataColor;
          } else if (dataColorGradient) {
            colColor.style.background = dataColorGradient;
          }          
          
          handleOptionsUpdate(options, trsEpoxyColor, dataVal);
        })
      })
    }
  }

  // height
  const productHeight = document.querySelector('.main-product').dataset.height;  

  const observer = new MutationObserver(() => {
    const options = document.querySelector('.bss-po-product-page');
    if (options) {
      observer.disconnect();
      handleOptionsUpdate(options, trsHeight, productHeight);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // update options
  function handleOptionsUpdate(options, optionType, model) {
    const optionsItems = options.querySelectorAll('.po-stack');
    optionsItems.forEach(item => {
      const currentOptionType = item.querySelector('.po-label span').textContent;
      const optionsButtons = item.querySelectorAll('.po-option--radioButton-wrapper');
  
      if (currentOptionType === optionType) { 
        changeOptions(optionsButtons, model);
      }
    });
  }
  
  // change options
  function changeOptions(array, element) {
    array.forEach(option => {
      const optionInput = option.querySelector('input');
      if (optionInput.value === element) {
        optionInput.click();
      }
    });
  }

  // warning options (start)
  function warningOptions(block) {    
    const drawerLabel = block.querySelector('.hc-drawer-label-js');
    const warningText = drawerLabel.parentNode.querySelector('.hc-label__warning');
    const drawerLabelText = block.querySelector('.variant__name_text');
    const drawerLabelOption = block.querySelector('.variant__name_option');
    const drawerOption = block.querySelector('.col-name');    

    if(drawerLabel.classList.contains('drawer__select_required')) {
      drawerLabel.classList.remove('drawer__select_required')
    }
    
    if(drawerLabel.classList.contains('drawer__select_warning')) {
      drawerLabel.classList.remove('drawer__select_warning')
    }

    if (warningText && warningText.classList.contains('hc-label__warning_active')) {
      warningText.classList.remove('hc-label__warning_active')
    }    

    if (drawerLabelText && !drawerLabelText.classList.contains('option_none')) {
      drawerLabelText.classList.add('option_none')
    }

    if (drawerLabelOption && drawerLabelOption.classList.contains('option_none')) {
      drawerLabelOption.classList.remove('option_none')
    }

    if (drawerOption && drawerOption.classList.contains('option_none')) {
      drawerOption.classList.remove('option_none')
    }
  }
  // warning options (end)

  function communicationForm(blocks, formInput) {   

    const timeoutId = setTimeout(() => {
      if (!body.classList.contains('from-collection')) {      
        blocks.forEach((block) => {
          const optionItems = block.querySelectorAll('.hc-drawer-val')
          
          optionItems.forEach((option) => {
            if (option.classList.contains('hc-drawer-val-active')) {
              formInput.value = option.dataset.colval
            }            
          })
        });

        clearTimeout(timeoutId);
      }
    }, 500);     
  }

  // loader Add to cart
  // if (productTemplate == 'rectangular') {
  //   const buttonAddToCart = document.querySelector('.product__cart-functions .add-to-cart');

  //   if (!buttonAddToCart.classList.contains('working')) {
  //     buttonAddToCart.classList.add('working')
  //   }  
    
  //   const observerBss = new MutationObserver((mutations, obs) => {
  //     const optionsBss = document.querySelector('.bss-po-product-page');
  //     if (optionsBss) {
  //       obs.disconnect();
  //       if (buttonAddToCart.classList.contains('working')) {
  //         buttonAddToCart.classList.remove('working')
  //       }
  //     }
  //   });

  //   observerBss.observe(document.body, { childList: true, subtree: true });
  // }  
})